export default __webpack_public_path__ + "static/media/G0750.34I-27930_-16871_0.1654019760000.4c075d84.jpg";